import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import { Formik } from 'formik';
import {validatePayment} from '../lib/validation';
import Fieldset from '../audi-ui-components/Fieldset';
import TextField from '../audi-ui-components/TextField';
import Select from '../audi-ui-components/Select';
import Button from '../audi-ui-components/Button';
import {formatCreditCard} from '../lib/helpers';
import IconVisa from './IconVisa';
import IconMastercard from './IconMastercard';
import IconAmex from './IconAmex';
import Loader from './Loader';

const mapStateToProps = (state) => {
    return {
        cart: state.shoppingCart.cart,
        donation: state.shoppingCart.donation,
        navBarActiveIndex: state.shoppingCart.navBarActiveIndex,
        disableNav: state.shoppingCart.disableNav,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchData: ACTIONS_CREATOR.fetchData,
    updateNavBarIndex: ACTIONS_CREATOR.updateNavBarIndex,
    disableNavItems: ACTIONS_CREATOR.disableNavItems,
    setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
    setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
    setFinalCart: ACTIONS_CREATOR.setFinalCart,
    setDonation: ACTIONS_CREATOR.setDonation,
    setDonationError: ACTIONS_CREATOR.setDonationError,
}, dispatch);


class PaymentForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            useDonationTextField: props.donation > 0 && props.donation !== 10 && props.donation !== 25 && props.donation !== 50,
            donationError: false
        };
        this.expYears = [];
    }

    componentDidMount() {
        if (window.Stripe) {
            window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_ADE_KEY);
        }
        this.props.disableNavItems(this.props.disableNav, CONST.PAYMENT_NAV_INDEX, false);
        var expYears = [];
        var currentYear = new Date().getFullYear();
        for (let i=0; i<10; i++) {
            let y = currentYear + i;
            expYears.push({label: `${y}`, value: `${y}`});
        }
        this.expYears = expYears;
        if (dataLayer) {
            const {cart} = this.props;
            var hasExperienceBooking = false;
            var hasCertificateOnline = false;
            for (let i=0; i<cart.items.length; i++) {
                if (cart.items[i].type === "ExperienceBooking") {
                    hasExperienceBooking = true;
                }
                if (cart.items[i].type === "GiftCard") {
                    hasCertificateOnline = true;
                }
            };
            dataLayer.push({'event': 'checkoutPayment', 'hasExperienceBooking': hasExperienceBooking, 'hasCertificateOnline': hasCertificateOnline});
        }
    }

    goToPDForm = () => {
        this.props.updateNavBarIndex(CONST.PERSONAL_NAV_INDEX);
    }

    handleSubmit = (values, actions) => {
        if (!window.Stripe) {
            this.props.setAlertMessage(true, 'danger', "Not connected to payment gateway");
            return;
        }

        const {cart, donation} = this.props;

        if (donation && donation > 0 && donation < 5) {
            this.setState({donationError: "The minimum donation amount is $5"});
            return;
        }

        this.props.setAlertMessage(true, 'success', 'Checking card details, please wait...');
        this.setState({loading: true});

        if (cart.balanceAmount > 0) {
            window.Stripe.card.createToken(values, (status, response) => {
                if (response.error) {
                    this.props.setAlertMessage(true, 'danger', response.error.message);
                    return;
                }
                const token = response.id;
                const cartId = this.props.cart.id;
                // add charge token to cart
                this.props.fetchData(
                    `/1/cart/${cartId}/charge`, 'POST',
                    {token}
                ).then((result) => {
                    this.props.setAlertMessage(true, 'success', 'Submitting order, please wait...');
                    this.props.setShoppingCart(result);
                    // submit order
                    this.props.fetchData(
                        `/1/cart/${cartId}/order`,
                        'POST'
                    ).then((response) => {
                        if (donation && donation > 0) {
                            this.submitDonation(values, response);
                        } else {
                            this.props.setAlertMessage(false);
                            this.props.setFinalCart(response);
                            this.props.updateNavBarIndex(CONST.CONFIRMATION_NAV_INDEX);
                        }
                    }).catch(err => {
                        this.setState({loading: false});
                        if (err && typeof err.then === 'function') {
                            err.then( errorMessage => {
                                // TODO: check (if modelState) to return more useful error messages
                                this.props.setAlertMessage(true, 'danger', errorMessage.message);
                            });
                        }
                    });
                }).catch(err => {
                    this.setState({loading: false});
                    err.then( errorMessage => {
                        this.props.setAlertMessage(true, 'danger', errorMessage.message);
                    });
                });
            });
        } else if (donation > 0) {
            this.submitDonation(values);
        }
    }

    submitDonation = (cardDetails, bookingResponse) => {
        this.props.setDonationError(false);
        window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_DONATE_KEY);
        setTimeout(() => {
            window.Stripe.card.createToken(cardDetails, (status, response) => {
                if (response.error) {
                    this.props.setDonationError(true);
                    window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_ADE_KEY);
                    this.props.setAlertMessage(false);
                    this.props.setFinalCart(bookingResponse);
                    this.props.updateNavBarIndex(CONST.CONFIRMATION_NAV_INDEX);
                } else {
                    let donationObj = {
                        chargeToken: response.id,
                        totalAmount: this.props.donation,
                        firstName: this.props.cart.firstName,
                        lastName: this.props.cart.lastName,
                        email: this.props.cart.email,
                        phoneNumber: this.props.cart.mobile,
                        source: "ADE",
                        optout: true,
                        optin: false
                    };
                    fetch(
                        `${process.env.RAZZLE_FOUNDATION_API}/api/v1/foundation/content/donate`,
                        {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Cache-Control': 'no-cache',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(donationObj)
                        }
                    ).then((response) => {
                        // console.log(response);
                        window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_ADE_KEY);
                        this.props.setAlertMessage(false);
                        this.props.setFinalCart(bookingResponse);
                        this.props.updateNavBarIndex(CONST.CONFIRMATION_NAV_INDEX);
                    }).catch((error) => {
                        console.error(error);
                        this.props.setDonationError(true);
                        window.Stripe.setPublishableKey(process.env.RAZZLE_STRIPE_ADE_KEY);
                        this.props.setAlertMessage(false);
                        this.props.setFinalCart(bookingResponse);
                        this.props.updateNavBarIndex(CONST.CONFIRMATION_NAV_INDEX);
                    });
                }
            });
        }, 500);
    }

    onClickDonation = (amt) => {
        if (this.props.donation === amt && !useTextfield) {
            this.props.setDonation(null);
        } else {
            this.props.setDonation(amt);
        }
        this.setState({useDonationTextField: false});
    }
    onChangeDonation = (amt) => {
        amt = amt.replace(/\D/g,'');
        this.props.setDonation(parseInt(amt));
        this.setState({useDonationTextField: true, donationError: false});
    }

    render() {
        const {cart, donation} = this.props;
        const {useDonationTextField} = this.state;
        var hasExperienceBooking = false;
        var requiresLicense = false;
        for (let i=0; i<cart.items.length; i++) {
          let item = cart.items[i];
          if (item.type === "ExperienceBooking") {
            hasExperienceBooking = true;
            if (CONST.noLicense[process.env.RAZZLE_APP_ENV].indexOf(item.program?.id) === -1) {
              requiresLicense = true;
            }
          }
        }
        return (
            <div className="mb-4 loading-wrapper">
                {this.state.loading && <Loader />}

                <header className="d-flex">
                    <h2 className="aui-headline-3">Personal Details</h2>
                    <Button onClick={this.goToPDForm} className="ms-auto p-2">edit</Button>
                </header>

                <p>{cart.firstName} {cart.lastName}</p>

                <div className="row">
                    <div className="col-auto">
                        Email: {cart.email}<br />
                        Contact number: {cart.mobile}
                    </div>
                    <div className="col-auto">
                        Postcode: {cart.postcode}<br />
                        DOB: {cart.birthDate}
                    </div>
                </div>
                {hasExperienceBooking && <div>
                    {requiresLicense && <div className="my-4">Driver's licence: {cart.licenseNumber}</div>}
                    <div>Dietary requirements: {cart.hasSpecialDiet ? <span>Yes</span> : <span>No</span>}</div>
                    <div>Notes: {cart.specialDietNote}</div>
                </div>}

                {CONST.FEATURE_TOGGLE.DONATION && <div className="aui-color-gray90 px-4 py-5 my-5">
                    <h2 className="aui-headline-3 mb-3"><b>Make a donation to the Audi Foundation</b></h2>
                    <p className="mb-5">The <a href="https://audifoundation.com.au" target="_blank" rel="noreferrer" className="aui-textlink">Audi Foundation</a> supports leading Australian charities with a focus on advancing medical technology, education, and positive mental health outcomes.</p>
                    <p className="mb-4 aui-headline-5">Make a donation (optional)</p>
                    <div style={{maxWidth:"370px"}}>
                        <div className="d-flex mb-3 mx-n2 donate-buttons">
                            <div className="px-2">
                                <Button
                                    variant={donation === 5 && !useDonationTextField ? "primary" : "secondary"}
                                    className={donation === 5 && !useDonationTextField ? "red" : ""}
                                    onClick={() => { this.onClickDonation(5); }}
                                >$5</Button>
                            </div>
                            <div className="px-2">
                                <Button
                                    variant={donation === 10 && !useDonationTextField ? "primary" : "secondary"}
                                    className={donation === 10 && !useDonationTextField ? "red" : ""}
                                    onClick={() => { this.onClickDonation(10); }}
                                >$10</Button>
                            </div>
                            <div className="px-2">
                                <Button
                                    variant={donation === 25 && !useDonationTextField ? "primary" : "secondary"}
                                    className={donation === 25 && !useDonationTextField ? "red" : ""}
                                    onClick={() => { this.onClickDonation(25); }}
                                >$25</Button>
                            </div>
                            <div className="px-2">
                                <Button
                                    variant={donation === 50 && !useDonationTextField ? "primary" : "secondary"}
                                    className={donation === 50 && !useDonationTextField ? "red" : ""}
                                    onClick={() => { this.onClickDonation(50); }}
                                >$50</Button>
                            </div>
                        </div>
                        <TextField
                            value={useDonationTextField ? donation : ""}
                            label="Or enter your own amount"
                            floatingLabel={false}
                            onChange={this.onChangeDonation}
                            icon={<b className="audiicon">$</b>}
                            isInvalid={Boolean(this.state.donationError)}
                            invalidMessage={this.state.donationError}
                        />
                    </div>
                </div>}

                <h2 className="mt-4 mb-2 aui-headline-3">Payment Method</h2>
                {cart.balanceAmount === 0 && (!donation || donation === 0) && <p>No payment required for this order.</p>}
                {(cart.balanceAmount > 0 || donation > 0) && <Formik
                    innerRef={this.props.forwardedRef}
                    initialValues={{
                        name: '',
                        number: '',
                        exp_month: '',
                        exp_year: '',
                        cvc: '',
                    }}
                    validate={validatePayment}
                    validateOnBlur={true}
                    onSubmit={this.handleSubmit}
                >
                    {({values, errors, touched, setFieldValue, setFieldTouched, handleChange, handleSubmit}) => (
                        <form id="paymentDetailsForm" noValidate onSubmit={handleSubmit}>
                            <div className="cc-icons">
                                <IconVisa />
                                <IconMastercard />
                                <IconAmex />
                            </div>
                            <div className="cc-details border px-4 pb-4 mt-3">
                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        <TextField
                                            name="number"
                                            label="Credit card number*"
                                            value={values.number}
                                            isInvalid={errors.number && touched.number}
                                            invalidMessage={errors.number}
                                            onChange= {(v, e) => { setFieldValue('number', formatCreditCard(v)); }}
                                            onBlur={() => { setFieldTouched('number'); }}
                                        />
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <TextField
                                            name="name"
                                            label="Name on Card*"
                                            value={values.name}
                                            isInvalid={errors.name && touched.name}
                                            invalidMessage={errors.name}
                                            onChange={(v, e) => { handleChange(e); }}
                                            onBlur={() => { setFieldTouched('name'); }}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 col-small-6">
                                        <Fieldset
                                            fields={[
                                                <Select name="exp_month"
                                                    label="Month"
                                                    floatingLabel={false}
                                                    value={values.exp_month}
                                                    options={[
                                                        {value: 1, label: '01'}, {value: 2, label: '02'}, {value: 3, label: '03'}, {value: 4, label: '04'}, {value: 5, label: '05'}, {value: 6, label: '06'},
                                                        {value: 7, label: '07'}, {value: 8, label: '08'}, {value: 9, label: '09'}, {value: 10, label: '10'}, {value: 11, label: '11'}, {value: 12, label: '12'}
                                                    ]}
                                                    isInvalid={errors.exp_month && touched.exp_month}
                                                    onChange={(v, e) => { handleChange(e); }}
                                                    onBlur={() => { setFieldTouched('exp_month'); }}
                                                />,
                                                <Select name="exp_year"
                                                    label="Year"
                                                    floatingLabel={false}
                                                    value={values.exp_year}
                                                    options={this.expYears}
                                                    isInvalid={errors.exp_year && touched.exp_year}
                                                    onChange={(v, e) => { handleChange(e); }}
                                                    onBlur={() => { setFieldTouched('exp_year'); }}
                                                />
                                            ]}
                                            title="Card expiry date"
                                            fieldType="selects"
                                            isInvalid={(errors.exp_months && touched.exp_months) || (errors.exp_year && touched.exp_year)}
                                            invalidMessage={errors.exp_month || errors.exp_year}
                                            className="cc-expiry form-field"
                                        />
                                    </div>
                                    <div className="col-12 col-small-6">
                                        <TextField
                                            name="cvc"
                                            label="CVV*"
                                            value={values.cvc}
                                            isInvalid={errors.cvc && touched.cvc}
                                            invalidMessage={errors.cvc}
                                            onChange= {(v, e) => { handleChange(e); }}
                                            onBlur={() => { setFieldTouched('cvc'); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
               </Formik>}
            </div>
         );
    }
}

PaymentForm.propTypes = {
    cart: PropTypes.object,
    fetchData: PropTypes.func,
    updateNavBarIndex: PropTypes.func,
    navBarActiveIndex: PropTypes.number,
    disableNav: PropTypes.array,
    disableNavItems: PropTypes.func,
    setAlertMessage: PropTypes.func,
    setShoppingCart: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentForm);
